var map = {
	"./../customer/customer.module": [
		"./src/app/layouts/customer/customer.module.ts",
		"default~customer-customer-module~layouts-admin-layout-admin-layout-module~quotation-quotation-module",
		"default~customer-customer-module~layouts-admin-layout-admin-layout-module"
	],
	"./../quotation/quotation.module": [
		"./src/app/layouts/quotation/quotation.module.ts",
		"default~customer-customer-module~layouts-admin-layout-admin-layout-module~quotation-quotation-module",
		"default~layouts-admin-layout-admin-layout-module~quotation-quotation-module"
	],
	"./../user/user.module": [
		"./src/app/layouts/user/user.module.ts",
		"default~layouts-admin-layout-admin-layout-module~user-user-module"
	],
	"./forgot-password/forgot-password.module": [
		"./src/app/forgot-password/forgot-password.module.ts",
		"forgot-password-forgot-password-module"
	],
	"./layouts/admin-layout/admin-layout.module": [
		"./src/app/layouts/admin-layout/admin-layout.module.ts",
		"default~customer-customer-module~layouts-admin-layout-admin-layout-module~quotation-quotation-module",
		"default~layouts-admin-layout-admin-layout-module~quotation-quotation-module",
		"default~customer-customer-module~layouts-admin-layout-admin-layout-module",
		"default~layouts-admin-layout-admin-layout-module~user-user-module",
		"layouts-admin-layout-admin-layout-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./set-password/set-password.module": [
		"./src/app/set-password/set-password.module.ts",
		"set-password-set-password-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;